// TODO: Update structure of Urls with proper naming conventions and base urls

const OVERTIME_REST_API_BASE_URL = process.env.NEXT_PUBLIC_OVERTIME_REST_API_BASE_URL ?? 'https://api.itsovertime.com';

export const Urls = {
	// Internal app routes
	Home: '/',
	About: '/about',
	Sfa: '/teams/saint-frances',
	Cch: '/teams/corner-canyon',

	// Overtime
	OvertimeRestApiBaseUrl: OVERTIME_REST_API_BASE_URL,
	OvertimeImagesBaseUrl: 'https://images.overtime.tv/',
	OvertimeTerms: 'https://overtime.tv/terms',
	OvertimePrivacy: 'https://overtime.tv/privacy',
	OvertimeDmca: 'https://overtime.tv/copyright',
	OvertimeShop: 'https://shop.overtime.tv/',
	NotificationsServer: 'wss://notifications.itsovertime.com',

	// Social
	YouTubeVideoBaseUrl: 'https://www.youtube.com/watch',
	YouTubeSocial: 'https://www.youtube.com/@OvertimeSZN',
	YouTubeSocialShorts: 'https://www.youtube.com/@OvertimeSZN/shorts',
	InstagramSocial: 'https://www.instagram.com/overtimeszn',
	TikTokSocial: 'https://www.tiktok.com/@overtimeszn',
	RestApiYouTubeVideos: `${OVERTIME_REST_API_BASE_URL}/api/youtube_videos/v1/feed?channel=szn&category=long_form&limit=50`,
	RestApiYouTubeShorts: `${OVERTIME_REST_API_BASE_URL}/api/youtube_videos/v1/feed?channel=szn&category=shorts&limit=6`,

	// Tickets / external tools
	VivenuTickets: 'https://tickets.itsovertime.com/event/ot-national-bp5gel',

	// Forms
	CredentialRequestForm:
		'https://docs.google.com/forms/d/e/1FAIpQLSeo_kl8gYP3jxB3wM_UmDelg_2W_1VfA5Y8jV42oyu1Z8_PUQ/viewform',

	// Articles
	SbjOtnArticle:
		'https://www.sportsbusinessjournal.com/Articles/2025/11/21/overtime-espn-omaha-productions-create-high-school-national-championships/',
};

// Event and game pages are linked from data (the featured event and game), never from fixed ids.
export const eventPath = (eventId: string) => `/events/${eventId}`;
export const gamePath = (gameId: string) => `/games/${gameId}`;
